import styled from 'styled-components';
export const FakeWrapper = styled.span`
  display: none;
`;
export const Screen = styled.span`
  display: none;
`;